import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import TouchableElement from '@components/common/touchableElement';
import EditableLine from '@components/common/editableLine';

import { font } from '@styles/fonts';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

export default ({ C, updateData, data, updateMachineAddressesInfo, setMode, MODES }) => {
  const submitDisabled = !data.fullName;

  return (
    <View>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
            <TouchableElement
              onPress={() => {
                setMode(MODES.SEARCH_MACHINES);
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15) }]}>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')) }, font.Body]}>{i18n.t('Cancel')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
          <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
            <TouchableElement
              onPress={() => {
                if (submitDisabled) {
                  return;
                }
                updateMachineAddressesInfo(data);
                setMode(MODES.SEARCH_MACHINES);
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15) }]}>
                  <Text style={[{ color: C(pressHoverColor(submitDisabled ? 'Label/Light/Quinary' : 'Link/Light/Primary')) }, font.Headline]}>
                    {i18n.t('Done')}
                  </Text>
                </View>
              )}
            </TouchableElement>
          </View>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Machine Name')}</Text>
        </View>
      </View>
      <View style={{ marginTop: scale(20), paddingHorizontal: isPhone ? 0 : scale(15) }}>
        <EditableLine
          {...{
            item: {
              value: data.fullName,
              key: 'fullName',
              placeholder: 'Machine Name',
              noArrow: true,
              isLable: false,
              onChange: (v) => updateData('fullName', v),
            },
            bg: modalFieldBg,
            index: 0,
            array: [{}],
            C,
            bottomBorderBox: isPhone,
            topBorderBox: isPhone,
            roundTop: !isPhone,
            roundBottom: !isPhone,
          }}
        />
      </View>
      <View style={{ marginBottom: scale(25) }}>
        <View style={{ marginTop: scale(20), paddingHorizontal: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>
            {i18n.t('IP address')}: {data.endpoint}
          </Text>
        </View>
        {data.ncFile && (
          <View style={{ marginTop: scale(25), paddingHorizontal: scale(15) }}>
            <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>{i18n.t('Selected NC File')}:</Text>
            <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>{data.ncFile}</Text>
          </View>
        )}
      </View>
    </View>
  );
};
